// extracted by mini-css-extract-plugin
export default {"imageWrapper":"VG-z","hovered":"WG-z","hoverImage":"XG-z","mainImage":"YG-z","imageNoBackground":"ZG-z","fullSizeImage":"_G-z"};